import { FC } from 'react'
import { useNavigate } from 'react-router'
import Chart from 'react-apexcharts'
import dayjs from 'dayjs'
import { BoxWithBorderNeon, Button, Icons, Link, Text } from 'components/atoms'
import { TextWithLabel } from 'components/molecules'
import { ROUTE_STORE_DETAIL } from 'constant'
import { About } from 'pages/About'
import Triagle from 'assets/images/triagle.png'
import Banner from 'assets/images/banner1.png'
import { useStore } from './hook'

const StoreLayout: FC<ReturnType<typeof useStore>> = ({
  series,
  optionsChart,
  machineInfo,
  xaxisPosition,
  forecast,
  renderEndChart,
  visibleLabelChart,
  xaxisWrapRef,
  enoughTarget,
  showText,
  params: { machineID, storeID, unitNo, calcNum },
  switchUi,
}) => {
  const navigate = useNavigate()
  if (switchUi) {
    return <About />
  }

  return (
    <div className="w-full flex flex-col gap-[18px]">
      <div className="w-full flex flex-col gap-10 min-h-[803px] pt-6 px-[15px] pb-[33px] bg-black rounded-[30px]">
        {(dayjs().isBefore(dayjs('2025-07-31').endOf('day')) ||
          dayjs().isSame(dayjs('2025-07-31').endOf('day'))) && (
          <div
            className="-mt-[10px] -mb-[24px] cursor-pointer"
            onClick={event => {
              event.stopPropagation()
              window.open('https://forms.gle/oTvScQEEZrFZwexN6', '_blank')
            }}
          >
            <img
              className="bg-cover w-full rounded-[14px]"
              src={Banner}
              alt="banner"
            />
          </div>
        )}
        <BoxWithBorderNeon className="gap-[20px]" type="pink">
          <div className="absolute w-full min-h-[270px] z-10 top-0 left-0">
            <div
              ref={xaxisWrapRef}
              className="relative w-[51%] min-h-[270px] top-0 left-[13.5%]"
            />
          </div>
          {enoughTarget ? (
            <>
              <div className="relative min-h-[270px] z-20">
                <div className="absolute w-full min-h-[240px] bottom-0 left-0">
                  <Chart
                    type="area"
                    options={optionsChart}
                    series={series}
                    height={'100%'}
                  />
                </div>
                <div className="absolute w-full h-full top-0 left-0">
                  <div className="relative w-[51%] h-full top-0 left-[13.5%]">
                    {visibleLabelChart &&
                      xaxisPosition.map(({ day, month, position }, index) => (
                        <LabelChart
                          key={index}
                          day={day}
                          month={month}
                          left={position || 0}
                        />
                      ))}
                  </div>
                </div>

                <div className="absolute w-full h-full top-0 left-0">
                  {renderEndChart && (
                    <div className="relative w-[40%] h-full top-0 left-[60%] wide-in-left">
                      <TextTopChart hasBorder left="-5px" top="30px" />
                      {forecast.up === 0 &&
                      forecast.flat === 0 &&
                      forecast.down === 0 ? (
                        <></>
                      ) : (
                        <>
                          <TextTopChart
                            text="3H後"
                            left="calc(100% - 42px)"
                            top="20px"
                          />
                          <div className="absolute w-[90%] h-[70%] top-[25%] left-[14px] bg-linechartAnimate bg-no-repeat bg-[length:100%_100%]" />
                          <div className="absolute flex flex-col top-10 right-8">
                            <div className="font-notoSans font-bold text-[13px] text-white chart-text-shadow">
                              上がる確率
                            </div>
                            <div className="flex items-center -mt-2 font-roboto font-bold text-[35px] text-white chart-text-shadow">
                              <div>{generateText(forecast.up).num}</div>
                              <div className="font-extrabold text-xl">
                                {generateText(forecast.up).text}
                              </div>
                            </div>
                          </div>
                          <div className="absolute flex items-center top-[57%] right-[5%] font-roboto font-semibold text-xs text-white ">
                            <div>{generateText(forecast.flat).num}</div>
                            <div className="text-[10px]">
                              {generateText(forecast.flat).text}
                            </div>
                          </div>
                          <div className="absolute flex items-center top-[80%] right-[12%] font-roboto font-semibold text-xs text-white ">
                            <div>{generateText(forecast.down).num}</div>
                            <div className="text-[10px]">
                              {generateText(forecast.down).text}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
                {visibleLabelChart && showText && (
                  <div className="absolute top-[50%] left-[25%] font-notoSans font-normal text-[15px] text-white">
                    3日間稼働なし
                  </div>
                )}
                {visibleLabelChart && (
                  <div className="absolute bottom-3 left-12 min-w-[255px] h-[58px] rounded-[10px] py-[6px] px-2 bg-[rgba(255,255,255,0.9)] shadow-borderPink font-notoSans font-normal text-[15px] text-[#202124] text-nowrap">
                    {forecast.up === 0 &&
                    forecast.flat === 0 &&
                    forecast.down === 0
                      ? '出玉傾向がマッチングしたデータは'
                      : 'AIによると、3時間後でこのような'}
                    <br />
                    {forecast.up === 0 &&
                    forecast.flat === 0 &&
                    forecast.down === 0
                      ? '存在しませんでした'
                      : '変化が起きる見込みです。'}
                  </div>
                )}
              </div>

              {forecast.up === 0 &&
              forecast.flat === 0 &&
              forecast.down === 0 ? (
                <></>
              ) : (
                <div className="px-5 z-20">
                  <Button
                    type="neon"
                    disabled={forecast.up <= 0}
                    onClick={event => {
                      event.stopPropagation()
                      if (forecast.up > 0) {
                        navigate(
                          `${ROUTE_STORE_DETAIL}?machine_id=${machineID}&store_id=${storeID}&unit_no=${unitNo}&calc_num=${calcNum}`,
                        )
                      }
                    }}
                  >
                    出玉解析をする
                  </Button>
                </div>
              )}
            </>
          ) : (
            <div className="absolute flex items-center justify-center h-full w-full z-20">
              <div className="rounded-[10px] py-[6px] px-2 bg-[rgba(255,255,255,0.9)] shadow-borderPink font-notoSans font-normal text-[15px] text-[#202124] text-nowrap">
                申し訳ありません、
                <br />
                出玉解析をするためのデータが
                <br />
                まだ十分に集まっていません。
                <br />
                「閉じる」を押して、また後日確認し
                <br />
                にきてください。
              </div>
            </div>
          )}
        </BoxWithBorderNeon>
        <BoxWithBorderNeon
          className="gap-[22px] px-[18px] py-[22px]"
          type="orange"
        >
          <Text
            text={machineInfo?.store_name || ''}
            className="text-center !text-[#FED8A9] !text-lg !font-bold text-shadow-custom"
          />
          <div className="flex gap-[7px] z-[5]">
            <div className="flex flex-1 flex-col gap-[10px]">
              <Text
                text={machineInfo?.machine_name || ''}
                className="px-[7.5px] py-[7px] bg-black custom-border !text-white !text-sm !font-normal"
              />
              <div className="w-full min-h-7 flex bg-black custom-border-6px ">
                <Text
                  text="台番号"
                  className="px-[7.5px] py-[2px] bg-linearNeon rounded-[5px] !text-white !text-base !leading-[20.48px]"
                />
                <Text
                  text={unitNo!}
                  className="flex flex-1 items-center justify-center !text-white !text-lg !leading-[23.04px]"
                />
              </div>
            </div>
            <div className="w-[106px] min-h-[106px] bg-white p-[11.68px] custom-border">
              <img
                src={`${process.env.REACT_APP_API_IMAGE}${machineInfo?.machine_img_uri}`}
                alt=""
              />
            </div>
          </div>
          <div className="w-full flex flex-col gap-[11px]">
            <TextWithLabel
              label="総スタート数"
              text={
                machineInfo?.pc_start === null ||
                machineInfo?.pc_start === undefined
                  ? '-'
                  : `${machineInfo?.pc_start}`
              }
              size={28}
            />
            <TextWithLabel
              label="大当り回数"
              text={
                machineInfo?.pc_hitcount === null ||
                machineInfo?.pc_hitcount === undefined
                  ? '-'
                  : `${machineInfo?.pc_hitcount}`
              }
              size={28}
            />
            <TextWithLabel
              label="初当り確率"
              text={
                machineInfo?.pc_firstrate === null ||
                machineInfo?.pc_firstrate === undefined
                  ? '-'
                  : machineInfo?.pc_firstrate !== 0
                    ? `1 / ${machineInfo?.pc_firstrate}`
                    : '-'
              }
              size={28}
            />
            <TextWithLabel
              label="大当り確率"
              text={
                machineInfo?.pc_hitrate === null ||
                machineInfo?.pc_hitrate === undefined
                  ? '-'
                  : machineInfo?.pc_hitrate !== 0
                    ? `1 / ${machineInfo?.pc_hitrate}`
                    : '-'
              }
              size={28}
            />
          </div>
        </BoxWithBorderNeon>
      </div>
      <div className="flex flex-col gap-6 items-center justify-center">
        <div className="flex gap-[6px]">
          <Icons.IconQA />
          <Link
            className="font-notoSans font-bold text-white text-base leading-[20.48px] underline decoration-solid"
            href="/FAQ.pdf"
            text="よくある質問"
            target="_blank"
          />
        </div>
        <div className="w-[84px]">
          <Button
            onClick={() => {
              window.close()
            }}
          >
            閉じる
          </Button>
        </div>
      </div>
    </div>
  )
}

const LabelChart: FC<{
  day: string
  month: string
  left: number | string
}> = ({ day, month, left }) => (
  <div
    className="absolute h-full flex flex-col items-center top-[20px]"
    style={{ left }}
  >
    <div className="relative flex items-center justify-center w-8 h-8 bg-[#D9D9D9] border-[0.33px] border-solid border-black rounded-[50%] font-roboto text-[9.8px] font-semibold leading-[8.71px] text-black">
      <div className="absolute w-[26px] h-[0.44px] bg-black rotate-[135deg]" />
      <div className="absolute top-[6px] left-[3px]">{month}</div>
      <div className="absolute bottom-1 right-1">{day}</div>
    </div>
    <div className="w-[0.86px] h-[75%] bg-white" />
  </div>
)

const TextTopChart: FC<{
  left: number | string
  top: number | string
  text?: string
  hasBorder?: boolean
}> = ({ text, left, top, hasBorder = false }) => (
  <div
    className="absolute h-full flex flex-col items-center"
    style={{ left, top }}
  >
    <div className="flex flex-col items-center">
      <div className="min-h-[21px] min-w-[42px] font-notoSans font-bold text-[14px] text-[#D9D9D9] chart-text-shadow">
        {text}
      </div>
      <div className="w-3 h-3">
        <img className="object-none" src={Triagle} alt="" />
      </div>
    </div>
    {hasBorder && (
      <div className="w-[2px] h-[75%] border-[1px] border-dashed border-white shadow-borderPink" />
    )}
  </div>
)

const generateText = (count: number) => {
  if (count < 5) {
    return {
      num: 5,
      text: '%未満',
    }
  }
  if (count >= 95) {
    return {
      num: 95,
      text: '％以上',
    }
  }
  return {
    num: count,
    text: '%',
  }
}

export const Store = () => {
  return <StoreLayout {...useStore()} />
}
